exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".olr .mainfe .class-room {\n  margin-right: 10%;\n  margin-left: 10%; }\n  .olr .mainfe .class-room .pointer {\n    cursor: pointer; }\n  .olr .mainfe .class-room .pointer:hover {\n    text-decoration: underline; }\n\n.slide-search {\n  background-color: #fafafa;\n  max-width: 400px;\n  transition: max-width 0.5s ease-out;\n  overflow: hidden; }\n\n.slide-search.ng-hide {\n  max-width: 0px; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/olr-mainfe-class/styles/index.scss
 ** module id = 229
 ** module chunks = 1
 **/